export const KeywordEndpoints = {
  getKeywords: (searchKey: string) => `palavras-chave/${searchKey}`,
};
